import React, { Component } from 'react';
import { Row, Col, Card, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { States } from '../../components/public/StatesSelect';
import './page-customer.less';
import CompanyService, { ICompanyInfo } from '../../service/company/CompanyService';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import TabsCustom from './CustomerTabs';
import { getCompanyUrlParam } from '../../utils';


interface CustomerPageProps {}

interface CustomerPageState {
    statesSelectValue: number | null,
    defaultSelectValue: States,
    isCompanySearchMode: boolean,
    showAlert: boolean,
    alertMessage: string,
    companyInfo: ICompanyInfo,
    activeTab: string,
}

class CustomerPage extends Component<CustomerPageProps, CustomerPageState> {
    
    state = {
        companyInputValue: null,
        statesSelectValue: States.normal,
        defaultSelectValue: States.normal,
        isCompanySearchMode: false,
        showAlert: false,
        alertMessage: '',
        companyInfo: null,
        activeTab: '1',
    };

    async componentDidMount() {
        const companyId = getCompanyUrlParam();
        this.setState({ statesSelectValue: States.normal });
    
        if (companyId !== -1) {
            const companyInfo = await CompanyService.getCompanyInfoById(companyId);
            if(companyInfo && companyInfo.data) {
                this.setState({ companyInfo: companyInfo.data.companyInfo });
            }
        }
    }

    //状态选择框事件处理
    handleStatesSelectChange = (value: any) => {
        this.setState({ statesSelectValue: value });
    };

    // 返回按钮点击事件处理
    handleBackButtonClick = () => {
        window.history.back();
    };

    // 添加Tab切换处理方法
    handleTabChange = (activeKey: string) => {
        this.setState({ activeTab: activeKey });
    };

    render() {
        const { companyInfo } = this.state;
        const companyName = companyInfo?.name ?? '客户信息列表';
        const companyEname = companyInfo?.ename ? ` (${companyInfo.ename})` : '';
        const companyCity = companyInfo?.province ? ` 城市：${companyInfo.province}` : '城市：未录入';
        const companyAddress = companyInfo?.address ? ` 地址：${companyInfo.address}` : '地址：未录入';
        const companyPhone = companyInfo?.phone ? ` 总机：${companyInfo.phone}` : '总机：未录入';
        const companyNature = companyInfo?.nature ? ` 性质：${companyInfo.nature}` : '性质：未录入';
        const companyIndustry = companyInfo?.industry ? ` 行业：${companyInfo.industry}` : '行业：未录入';
        const companyWebsite = companyInfo?.website ? ` 网址：${companyInfo.website}` : '网址：未录入';
        const companyPostal = companyInfo?.postal ? ` 邮编：${companyInfo.postal}` : '邮编：未录入';
        const companyFax = companyInfo?.fax ? ` 传真：${companyInfo.fax}` : '传真：未录入';
        const companyRemark = companyInfo?.remark ? ` 备注：${companyInfo.remark}` : '';

        return (
            <ErrorBoundary>
                <div className="gutter-customer_container">
                    <BreadcrumbCustom breads={['公司信息管理', '客户信息列表']} />
                    <Row gutter={5}>
                        <Col className="gutter-user_row" md={25}>
                            <div className="gutter-user_box">
                                <Card
                                    title={
                                        <div className="title-container">
                                            <Button type="link" className="back-button" onClick={this.handleBackButtonClick}>
                                                {'< 返回'}
                                            </Button>
                                            <span className="company-name">{companyName}{companyEname}</span>
                                        </div>
                                    }
                                    bordered={false}
                                >
                                    <div style={{ marginBottom: 16 }}>
                                        <div style={{ marginBottom: 20 }}>
                                            <label className="lable-first">{companyCity}</label>
                                            <label className="lable-second">{companyNature}</label>
                                            <label className="lable-third">{companyPostal}</label>
                                            <label className="lable-last">{companyAddress}</label>
                                        </div>
                                        <div style={{ marginBottom: 20 }}>
                                            <label className="lable-first">{companyPhone}</label>
                                            <label className="lable-second">{companyIndustry}</label>
                                            <label className="lable-third">{companyFax}</label>
                                            <label className="lable-last">{companyWebsite}</label>

                                        </div>
                                        {companyRemark !== '' && (
                                            <div style={{ marginBottom: 20 }}>
                                                <label className="lable-remark">{companyRemark}</label>
                                            </div>
                                        )}

                                        <div style={{ display: 'flex'}}>
                                            <TabsCustom
                                                activeKey={this.state.activeTab}
                                                onChange={this.handleTabChange}
                                            />
                                        </div>

                                    </div>

                                </Card>
                            </div>
                        </Col>
                    </Row>
                </div>
            </ErrorBoundary>
        );
    }
}

export default CustomerPage;